import { Component, OnInit } from '@angular/core';
import { SelectMultipleControlValueAccessor } from '@angular/forms';
import { Router } from '@angular/router';
import { QuestItemService } from '../quest-item.service';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../../login.service';

@Component({
  selector: 'qst-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  constructor( private router: Router,
    private questItemService: QuestItemService,
    private http: HttpClient,
    private loginService: LoginService ) { }

  ngOnInit(): void {
    //this.router.navigateByUrl( '/quest' );
    console.log("LOADING ....");
    this.questItemService.getQuestItemsFromServer(this.loginService.getEventId(), this.loginService.getTeamId());

    // Check/Load Team Information
    

    // If successful, load quests.

    // else, set an error and route back to login page
  }

  loginAndLoad() {
    /*
    this.http.get('http://herenow.live/service.php').subscribe((responseBody) => {
      //this.questItems = <QuestItems[]>responseBody;
    }
    */
  }



  

}
